export const DISPLAY_DATE_FORMAT = {
    parse: {
        dateInput: 'YYYY-MM-DD',
    },
    display: {
        dateInput: 'DD-MMM-YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

export const SERVER_DATE_FORMAT_WITHOUT_TIME = 'YYYY-MM-DD';
export const SERVER_DATE_FORMAT_WITH_TIME = 'YYYY-MM-DD HH:mm:ss';
